/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 24/08/22
 */

import { MetricsBox } from '@/components/MetricsBox';
import { toTruncatedFixed } from '@/wpt-lib/utils/toTruncatedFixed';
import { Container, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import React from 'react';

export interface LeaveValues {
    bookedAnnualLeaveDays: number;
    bookedOtherLeaveDays: number;
    plannedAnnualDays: number;
    plannedOtherLeaveDays: number;
}

export const LeaveStats = ({ values }: { values: LeaveValues }) => {
    const bookedAnnualLeave = toTruncatedFixed(values.bookedAnnualLeaveDays, 1);
    const bookedOtherLeave = toTruncatedFixed(values.bookedOtherLeaveDays, 1);
    const plannedAnnualLeave = toTruncatedFixed(values.plannedAnnualDays, 1);
    const plannedOtherLeave = toTruncatedFixed(values.plannedOtherLeaveDays, 1);
    const totalPlannedLeave = toTruncatedFixed(values.plannedAnnualDays + values.plannedOtherLeaveDays, 1);
    const totalBookedLeave = toTruncatedFixed(values.bookedAnnualLeaveDays + values.bookedOtherLeaveDays, 1);

    return (
        <Container centerContent>
            <Table variant="unstyled" size="sm" width="100%" color="blue.500">
                <caption style={{ opacity: 0, height: '1px' }}>Leave Summary</caption>
                <Thead>
                    <Tr>
                        <Th
                            textTransform="none"
                            textAlign="left"
                            fontSize="md"
                            letterSpacing="none"
                            style={{ opacity: 0 }}
                            scope="row"
                        >
                            Leave Type
                        </Th>
                        <Th textTransform="none" textAlign="center" fontSize="md" letterSpacing="none">
                            Annual Leave
                        </Th>
                        <Th textTransform="none" textAlign="center" fontSize="md" letterSpacing="none">
                            Other Leave
                        </Th>
                        <Th textTransform="none" textAlign="center" fontSize="md" letterSpacing="none">
                            Total
                        </Th>
                    </Tr>
                </Thead>
                <Tbody>
                    <Tr>
                        <Th textTransform="none" textAlign="left" fontSize="md" letterSpacing="none" scope="row">
                            Booked
                        </Th>
                        <Td textTransform="none" textAlign="center" fontSize="md" letterSpacing="none">
                            <MetricsBox value={bookedAnnualLeave} />
                        </Td>
                        <Td textTransform="none" textAlign="center" fontSize="md" letterSpacing="none">
                            <MetricsBox value={bookedOtherLeave} />
                        </Td>
                        <Td textTransform="none" textAlign="center" fontSize="md" letterSpacing="none">
                            <MetricsBox value={totalBookedLeave} />
                        </Td>
                    </Tr>
                    <Tr>
                        <Th textTransform="none" textAlign="left" fontSize="md" letterSpacing="none" scope="row">
                            Planned
                        </Th>
                        <Td textTransform="none" textAlign="center" fontSize="md" letterSpacing="none">
                            <MetricsBox value={plannedAnnualLeave} />
                        </Td>
                        <Td textTransform="none" textAlign="center" fontSize="md" letterSpacing="none">
                            <MetricsBox value={plannedOtherLeave} />
                        </Td>
                        <Td textTransform="none" textAlign="center" fontSize="md" letterSpacing="none">
                            <MetricsBox value={totalPlannedLeave} />
                        </Td>
                    </Tr>
                </Tbody>
            </Table>
        </Container>
    );
};

export default LeaveStats;
